import { render, staticRenderFns } from "./yikureceiveForm.vue?vue&type=template&id=01c77879&scoped=true&"
import script from "./yikureceiveForm.vue?vue&type=script&lang=js&"
export * from "./yikureceiveForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c77879",
  null
  
)

export default component.exports